import React from "react";
import Head from "next/head";

function Policy() {
  return (
    <div className="h-screen bg-white px-2 py-4">
      <Head>
        <title>Privacy Policy</title>
      </Head>
      <iframe
        title="Fundview Policy"
        width="100%"
        height="100%"
        src="https://fvsiteprodst01.blob.core.windows.net/public/privacy.htm"
      />
    </div>
  );
}

export default Policy;
